import { render, staticRenderFns } from "./newHeader.vue?vue&type=template&id=c2a26050&scoped=true"
import script from "./newHeader.vue?vue&type=script&lang=js"
export * from "./newHeader.vue?vue&type=script&lang=js"
import style0 from "./newHeader.vue?vue&type=style&index=0&id=c2a26050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a26050",
  null
  
)

export default component.exports